// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"input_wrapper_xauP2","error":"input_error_1LPLE"};